// extracted by mini-css-extract-plugin
export default {"section":"Updates_section__XMKMR","separator":"Updates_separator__KtMxH","tutorialImage":"Updates_tutorialImage__7qvoJ"};